<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">
      <div class="spacer2"></div>

      <div class="containter">
        <div class="mfhd">
          <i class="fa fa-angle-left" aria-hidden="true" style="padding-right: 5px"></i>Users
          <div class="page-description" style="
              color: #9c9b9b;
              font-size: 14px;
              margin-top: 8px;
              margin-bottom: 16px;
            ">
            Users within a workspace who can create, access, and
            interact with memories and other features.
          </div>
        </div>

        <div class="example-container">
          <button mat-raised-button color="primary" [routerLink]="['/add-user']" class="btn-send clr-white"
            style="float: right">
            + Create
          </button>

          <table mat-table [dataSource]="users?.data?.profiles" class="mat-elevation-z8">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Profile Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element?.name }}<br />
                {{ element?.identification }}
              </td>
            </ng-container>

            <ng-container matColumnDef="userkey">
              <th mat-header-cell *matHeaderCellDef>Key</th>
              <td mat-cell *matCellDef="let element">
                <div class="min fl-left" id="myInput">
                  {{ maskUserKey(element.userkey) }}
                </div>
                <i class="fa-solid fa-clone pointer fl-left routeClr" matTooltip="Copy"
                  (click)="copyMessage(element?.userkey)" style="margin-left: 3px"></i>
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let element">
                <i class="fa-solid fa-chart-line routeClr pointer" (click)="routeDashboard(element?.userkey)"
                  matTooltip="Dashboard"></i> |
                <i class="fa-solid fa-brain routeClr pointer" (click)="routeMemory(element?.userkey)"
                  matTooltip="Memory"></i> |
                <i class="fa-solid fa-bell routeClr pointer" matTooltip="Reminder" style="padding-left: 10px"
                  (click)="routeReminder(element?.userkey)"></i> |
                <i class="fa-solid fa-comments routeClr pointer" matTooltip="Chat" style="padding-left: 10px"
                  (click)="routeChat(element?.userkey)"></i> |
                <i class="fa-solid fa-download routeClr pointer" matTooltip="Download MCP Config"
                  style="padding-left: 10px" (click)="openMcpConfigDialog(element?.userkey)"></i>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center; height: 50vh">
                {{ loading ? "Loading..." : "No data found" }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>